import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';

const PrivateRoutes = () => {
  const token = useSelector((state: StateProps) => state.tokenInfo.accessToken);
  return token === 'No token' ? <Navigate replace to="/" /> : <Outlet />;
};

export default PrivateRoutes;
